import { render, staticRenderFns } from "./AlertasVigilantiPantalla.vue?vue&type=template&id=74829034&"
import script from "./AlertasVigilantiPantalla.vue?vue&type=script&lang=ts&"
export * from "./AlertasVigilantiPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports